var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26704",
      "ably-hubspot-js": "static-2.3379",
      "breadcrumbs-ui": "static-1.1890",
      "client-types": "static-1.373",
      "enviro": "static-4.306",
      "head-dlb": "static-1.4003",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4333",
      "hs-test-utils": "static-1.6800",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3161",
      "HubStyleTokens": "static-2.10300",
      "I18n": "static-7.1391",
      "jasmine-runner": "static-1.5208",
      "nav-client-types": "static-1.1156",
      "nav-meta": "static-1.25497",
      "navigation-components": "static-1.13860",
      "navigation-components-tests": "static-1.10470",
      "navigation-messaging": "static-1.3187",
      "quartz": "static-1.5554",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3518",
      "trials-service-types": "static-1.2894",
      "target-element-observer": "static-1.1000",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5736",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.30033",
      "classnames": "static-2.10",
      "crosstab": "static-1.3411",
      "ExtensionInstallHelpers": "static-1.536",
      "foundations-components": "static-1.6001",
      "foundations-theming": "static-1.3124",
      "foundations-theming-base": "static-1.2109",
      "foundations-theming-specialty": "static-1.841",
      "frontend-preferences-client": "static-1.6673",
      "global-search-externals": "static-1.11311",
      "idb-keyval": "static-1.20",
      "magpie-lib": "static-1.4476",
      "magpie-types": "static-1.3936",
      "metrics-js": "static-1.8576",
      "nav-onboarding-tours": "static-1.2280",
      "notification-sounds": "static-1.3238",
      "prefetcher": "static-1.4583",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4323",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6980",
      "simple-logging-lib": "static-1.1838",
      "styled-components": "static-2.64",
      "superstore": "static-1.3574",
      "trial-components-library": "static-1.10912",
      "ts-schema": "static-1.3134",
      "ui-images": "static-2.834",
      "usage-tracker-core": "static-1.6120",
      "hs-promise-rejection-tracking": "static-1.4306",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4766",
      "raven-hubspot": "static-1.5073",
      "bend-plugin-trellis-migration": "static-1.2451",
      "moment": "static-3.26",
      "quartz-core": "static-1.4773",
      "HeadJS": "static-2.577",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1911",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.197",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3142",
      "quartz-core-utils": "static-1.2421",
      "StyleGuideUI": "static-3.461",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10609",
      "calling-error-reporting": "static-1.30039",
      "calling-usage-tracker": "static-1.5295",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.9009",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7248",
      "bend-plugin-foundations-components": "static-1.2269",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3729",
      "hs-story-utils": "static-1.8197",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-theming": "static-1.1607",
      "hub-http-janus": "static-1.648",
      "global-search-shared": "static-1.12026",
      "usage-tracker": "static-1.6270",
      "autolinker": "static-3.11",
      "sanitize": "static-1.3189",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.5237",
      "atom": "static-1.4014",
      "copilot-toolkit": "static-1.6377",
      "demographics-client": "static-1.4214",
      "hubs-service-types": "static-1.265",
      "icons": "static-2.592",
      "laboratory-lib": "static-3.6058",
      "onboarding-scopes": "static-1.5359",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.500",
      "signup-constants": "static-1.16273",
      "ui-addon-i18n": "static-1.9727",
      "ui-addon-upgrades": "static-9.16038",
      "user-context": "static-1.3977",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.7064",
      "hubspotter-http": "static-1.3584",
      "hubspotter-http-shared-msw-handlers": "static-1.7062",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11213",
      "react-rhumb": "static-1.15381",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.494",
      "customer-data-ui-utilities": "static-1.8528",
      "ai-addon-copilot-preview": "static-1.4449",
      "apollo-link-hub-http": "static-2.3583",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8419",
      "graphql": "static-1.58",
      "search-service-types": "static-1.2784",
      "chatspot-client-types": "static-1.8580",
      "chatspot-core": "static-1.15618",
      "ContentUtils": "static-1.63280",
      "sassPrefix": "static-1.131",
      "foundations-components-test-utils": "static-1.3486",
      "feature-store-service-types": "static-1.3486",
      "growth-monetization-service-types": "static-1.3493",
      "upgrade-management-service-types": "static-1.3477",
      "getting-started-shared-tasks": "static-1.12620",
      "getting-started-shared-tasks-store": "static-1.11738",
      "platform-infra-nav-components": "static-1.6692",
      "react-dnd-compat": "static-1.3459",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.5919",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.3591",
      "content-icons-ui": "static-1.1891",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8156",
      "ui-addon-react-router-dom": "static-1.8411",
      "usage-tracker-container": "static-1.6260"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26704",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3379",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.1890",
      "client-types": "/client-types/static-1.373",
      "enviro": "/enviro/static-4.306",
      "head-dlb": "/head-dlb/static-1.4003",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4333",
      "hs-test-utils": "/hs-test-utils/static-1.6800",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3161",
      "HubStyleTokens": "/HubStyleTokens/static-2.10300",
      "I18n": "/I18n/static-7.1391",
      "jasmine-runner": "/jasmine-runner/static-1.5208",
      "nav-client-types": "/nav-client-types/static-1.1156",
      "nav-meta": "/nav-meta/static-1.25497",
      "navigation-components": "/navigation-components/static-1.13860",
      "navigation-components-tests": "/navigation-components-tests/static-1.10470",
      "navigation-messaging": "/navigation-messaging/static-1.3187",
      "quartz": "/quartz/static-1.5554",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3518",
      "trials-service-types": "/trials-service-types/static-1.2894",
      "target-element-observer": "/target-element-observer/static-1.1000",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5736",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.30033",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3411",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.536",
      "foundations-components": "/foundations-components/static-1.6001",
      "foundations-theming": "/foundations-theming/static-1.3124",
      "foundations-theming-base": "/foundations-theming-base/static-1.2109",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.841",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6673",
      "global-search-externals": "/global-search-externals/static-1.11311",
      "idb-keyval": "/idb-keyval/static-1.20",
      "magpie-lib": "/magpie-lib/static-1.4476",
      "magpie-types": "/magpie-types/static-1.3936",
      "metrics-js": "/metrics-js/static-1.8576",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2280",
      "notification-sounds": "/notification-sounds/static-1.3238",
      "prefetcher": "/prefetcher/static-1.4583",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4323",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6980",
      "simple-logging-lib": "/simple-logging-lib/static-1.1838",
      "styled-components": "/styled-components/static-2.64",
      "superstore": "/superstore/static-1.3574",
      "trial-components-library": "/trial-components-library/static-1.10912",
      "ts-schema": "/ts-schema/static-1.3134",
      "ui-images": "/ui-images/static-2.834",
      "usage-tracker-core": "/usage-tracker-core/static-1.6120",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4766",
      "raven-hubspot": "/raven-hubspot/static-1.5073",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2451",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4773",
      "HeadJS": "/HeadJS/static-2.577",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1911",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.197",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3142",
      "quartz-core-utils": "/quartz-core-utils/static-1.2421",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10609",
      "calling-error-reporting": "/calling-error-reporting/static-1.30039",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5295",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.9009",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7248",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2269",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3729",
      "hs-story-utils": "/hs-story-utils/static-1.8197",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1607",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "global-search-shared": "/global-search-shared/static-1.12026",
      "usage-tracker": "/usage-tracker/static-1.6270",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.3189",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5237",
      "atom": "/atom/static-1.4014",
      "copilot-toolkit": "/copilot-toolkit/static-1.6377",
      "demographics-client": "/demographics-client/static-1.4214",
      "hubs-service-types": "/hubs-service-types/static-1.265",
      "icons": "/icons/static-2.592",
      "laboratory-lib": "/laboratory-lib/static-3.6058",
      "onboarding-scopes": "/onboarding-scopes/static-1.5359",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.500",
      "signup-constants": "/signup-constants/static-1.16273",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9727",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16038",
      "user-context": "/user-context/static-1.3977",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7064",
      "hubspotter-http": "/hubspotter-http/static-1.3584",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7062",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11213",
      "react-rhumb": "/react-rhumb/static-1.15381",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.494",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8528",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4449",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3583",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8419",
      "graphql": "/graphql/static-1.58",
      "search-service-types": "/search-service-types/static-1.2784",
      "chatspot-client-types": "/chatspot-client-types/static-1.8580",
      "chatspot-core": "/chatspot-core/static-1.15618",
      "ContentUtils": "/ContentUtils/static-1.63280",
      "sassPrefix": "/sassPrefix/static-1.131",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3486",
      "feature-store-service-types": "/feature-store-service-types/static-1.3486",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3493",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3477",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12620",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11738",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6692",
      "react-dnd-compat": "/react-dnd-compat/static-1.3459",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5919",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.3591",
      "content-icons-ui": "/content-icons-ui/static-1.1891",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8411",
      "usage-tracker-container": "/usage-tracker-container/static-1.6260"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};